import { render, staticRenderFns } from "./msn-delta.vue?vue&type=template&id=9f5a2f5a&lang=pug&"
import script from "./msn-delta.vue?vue&type=script&lang=js&"
export * from "./msn-delta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports